/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { useLazyQuery, gql } from '@apollo/client';

export const useAutoSuggestionView = () => {

    const AUTO_SUGGESTION_GQL = gql`
    query AutoSuggestionView($langId: String!) {
        autoSuggestionView(langId: $langId) {
            suggestionView {
                autoSuggestionViewCategory {
                    categorySeparator
                    entry {
                    fullPath
                    fullPathCategoryIds
                    name
                    shortDescription
                    value
                    }
                    identifier
                }
            }
        }
    }`

  const [FetchSuggestionQuery, SuggestionData] = useLazyQuery(AUTO_SUGGESTION_GQL,{fetchPolicy:"cache-first",context:{clientName:"search"}});
  
  return { FetchSuggestionQuery, SuggestionData };
};